import React from "react";

const disclaimer = (props) => {
  return (
    <div className="container disclaimer">
      *This calculator is provided for informational purposes
      only and Pacific Premier Bank does not guarantee the accuracy of the
      results produced by the calculator. Pacific Premier Bank shall not be
      responsible for any errors or omissions related to user’s use of the
      calculator. The calculator is not intended to provide financial advice or
      be used as an investment advisory tool. Use of the calculator does not
      create a banking relationship between the user and Pacific Premier Bank.
      Pacific Premier Bank disclaims all liability relating to user’s use of the
      calculator and user assumes all risk related thereto.
    </div>
  );
};

export default disclaimer;
